<template>
  <div class="line-select">
    <a-select
      v-model:value="selectValue"
      :style="{ width: widthStyle }"
      :placeholder="placeholder"
      :show-search="showSearch"
      :filter-option="filterOption"
      @change="$emit('')"
    >
      <a-select-option
        v-for="(item, index) in selectList"
        :key="index"
        :value="item[valueName]"
      >
        {{ item[labelName] }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
export default {
  name: 'LineSelect',
  props: {
    value: {
      type: [String, Number],
      default: undefined,
    },
    selectList: {
      type: Array,
      default: () => {
        return []
      },
    },
    placeholder: {
      type: String,
      default: 'Please select',
    },
    valueName: {
      type: String,
      default: 'value',
    },
    labelName: {
      type: String,
      default: 'label',
    },
    width: {
      type: [String, Number],
      default: '100%',
    },
    showSearch: {
      type: Boolean,
      default: false,
    },
    filterOption: {
      type: [Boolean, Function],
      default: false,
    },
  },
  computed: {
    selectValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('update:value', v)
      },
    },
    widthStyle() {
      return typeof this.width === 'string' ? this.width : `${this.width}px`
    },
  },
}
</script>

<style lang="scss">
.line-select {
  .ant-select-single:not(.ant-select-customize-input) {
    .ant-select-selector {
      border-left: none;
      border-right: none;
      border-top: none;
      box-shadow: none !important;
      &:hover {
        border-left: none;
        border-right: none;
        border-top: none;
        box-shadow: none;
      }
    }
  }
}
</style>
